// Module-level singleton MessageCache instance.
// Shared across useEsaConverse, ESAChatView, and any other consumer.
// Exported via getMessageCache() for testability (can be mocked in tests).
import { MessageCache } from './MessageCache';

let _instance: MessageCache | null = null;

export function getMessageCache(): MessageCache {
  if (!_instance) {
    _instance = new MessageCache({ maxThreads: 20, maxMessagesPerThread: 200 });
  }
  return _instance;
}

/** Reset singleton — for use in tests only. */
export function resetMessageCacheForTesting(): void {
  _instance = null;
}
